import React from 'react';
import { Button, Form } from 'antd';
import { ButtonGroup, Drawer } from '@common/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CREATE_UNIT_SHIFT_GAP_TAG_MUTATION } from '@scheduling/graphql/mutations/unit-shift-gap-tag';
import {
  UnitShiftGapTagForm,
  unitShiftGapTagFormNameErrorsHandler,
} from '@scheduling/components';

export function UnitShiftGapTagCreateDrawer({
  open,
  onClose,
  organizationUnitId,
}: {
  open: boolean;
  onClose: () => void;
  organizationUnitId?: string;
}) {
  const [form] = Form.useForm();

  const [createTag, { loading }] = useMutation(
    CREATE_UNIT_SHIFT_GAP_TAG_MUTATION,
    {
      refetchQueries: ['UnitShiftGapTagsQuery'],
    }
  );

  function handleClose() {
    form.resetFields();
    onClose();
  }

  async function handleFinish(values: { name: string; description?: string }) {
    try {
      const response = await createTag({
        variables: {
          input: {
            name: values.name,
            description: values.description || null,
            organizationUnitId,
          },
        },
      });

      const mutationErrors = response?.data?.createShiftGapTag?.errors;

      if (mutationErrors?.length) {
        unitShiftGapTagFormNameErrorsHandler(form, mutationErrors);
        return;
      }

      if (response?.errors?.length) {
        createMessage(
          'error',
          response.errors.map((e) => e.message).join(', ')
        );
        return;
      }

      createMessage('success', 'Shift tag created successfully.');
      handleClose();
    } catch {
      createMessage(
        'error',
        'Something went wrong. Try again later or contact support.'
      );
    }
  }

  const footer = (
    <ButtonGroup>
      <Button size="large" onClick={handleClose}>
        Cancel
      </Button>
      <Button
        type="primary"
        size="large"
        loading={loading}
        onClick={form.submit}
      >
        Save
      </Button>
    </ButtonGroup>
  );

  return (
    <Drawer
      open={open}
      title="Add Shift Tag"
      footer={footer}
      onClose={handleClose}
    >
      <UnitShiftGapTagForm form={form} onFinish={handleFinish} />
    </Drawer>
  );
}
